@if (currentPlatform$ | async; as currentPlatform) {
  <div
    #container
    class="create-post create-post_padding"
    [class.create-post-web]="
      !isMobModalOpen || (isEditMode && currentPlatform === CurrentPlatform.desktop)
    "
    [class.edit-post]="isEditMode && currentPlatform === CurrentPlatform.desktop"
    appClickOutside
    (clickOutside)="closeForm(chosenFiles)"
  >
    @if (currentUser$ | async; as currentUser) {
      @if (isMobModalOpen || (isEditMode && currentPlatform !== CurrentPlatform.desktop)) {
        <ion-header [class.ion-no-border]="currentPlatform !== CurrentPlatform.desktop">
          <ion-toolbar>
            <app-text
              [textSize]="TextSizes.h1Header"
              [textType]="TextType.base"
              [text]="isEditMode ? 'Редактирование' : 'Что у вас нового?'"
            ></app-text>
            <ion-buttons slot="end">
              <ion-icon
                (click)="cancelPostCreation()"
                slot="icon-only"
                src="assets/images/icons-svg/close.svg"
                class="close-icon"
              ></ion-icon>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
      }
      <form
        class="create-post__form"
        [formGroup]="newPostFormGroup"
        [class.create-post__form-mob]="
          isMobModalOpen || (isEditMode && currentPlatform !== CurrentPlatform.desktop)
        "
      >
        <ion-grid>
          <div class="create-post__form-content">
            <ion-row class="ion-align-items-start">
              @if (
                !isMobModalOpen || (!isEditMode && currentPlatform === CurrentPlatform.desktop)
              ) {
                <ion-col size=".8" class="col-avatar">
                  @if (currentUser$ | async; as currentUser) {
                    <div class="avatar">
                      <app-image
                        [img]="(currentUser?.avatar?.previewNormal | addBaseUrl) ?? ''"
                      ></app-image>
                    </div>
                  }
                </ion-col>
              }
              <ion-col class="col-text">
                <div class="content">
                  <ion-textarea
                    #ionTextArea
                    [rows]="1"
                    [autofocus]="currentPlatform !== CurrentPlatform.desktop"
                    formControlName="msg"
                    [class.textarea-shown]="
                      isCreatePostOpen ||
                      isCreatePollOpen ||
                      form['poll'].value ||
                      isMobModalOpen ||
                      isEditMode
                    "
                    (ionFocus)="isCreatePostOpen = true"
                    spellcheck="true"
                    autocomplete="off"
                    autocapitalize="true"
                    placeholder="Написать пост"
                    maxlength="5000"
                    auto-grow="true"
                    [ngStyle]="
                      currentPlatform === CurrentPlatform.desktop
                        ? null
                        : { 'max-height': textAreaMaxHeight }
                    "
                  ></ion-textarea>
                </div>
              </ion-col>
              @if (
                !isMobModalOpen &&
                currentPlatform === CurrentPlatform.desktop &&
                currentUser.userRole === userRoles.moderator
              ) {
                <ion-col size=".3" class="col-icons">
                  @if (!isCreatePostOpen && !form['poll'].value && !isEditMode) {
                    <div class="icon-poll" (click)="isCreatePostOpen = true; openPollWebModal()">
                      <div>
                        <ion-icon src="assets/images/icons-svg/posts/poll.svg"></ion-icon>
                      </div>
                    </div>
                  }
                </ion-col>
              }
              @if (chosenFiles.length) {
                <div
                  class="new-post-content__files"
                  [class.mobile-post-creation]="currentPlatform !== CurrentPlatform.desktop"
                >
                  <div
                    #imagesContainer
                    [class.mb]="currentPlatform === CurrentPlatform.desktop && !!form['poll'].value"
                    [class.uploaded-images]="
                      chosenFiles.length && chosenFiles[0].fileType === FileType.image
                    "
                  >
                    @for (file of chosenFiles; track file) {
                      @if (file.fileType === FileType.image) {
                        @if (!file.error) {
                          <div class="uploaded-images__item">
                            <img
                              [src]="file.localUrl"
                              [class.loading]="file.isLoading"
                              draggable="false"
                              class="uploaded-images__item__image"
                            />
                            <img
                              class="delete-image"
                              src="assets/images/icons-svg/delete-icon-black.svg"
                              (click)="utils.handleDeleteChosenImage(file.localId)"
                            />
                            @if (file.isLoading) {
                              <div class="spinner">
                                <ion-spinner color="light" name="circular"></ion-spinner>
                              </div>
                            }
                          </div>
                        }
                      }
                      @if (file.fileType === FileType.file) {
                        <app-file-upload
                          [id]="file.localId"
                          [fileTitle]="file.localName"
                          type="file"
                          mode="create"
                          (deleteItem)="utils.handleDeleteChosenImage(file.localId)"
                          [currentPlatform]="currentPlatform"
                          [isLoading]="file.isLoading"
                        ></app-file-upload>
                      }
                    }
                  </div>
                  @if (chosenFiles.length > (isEditMode ? 3 : 4)) {
                    @if (showLeftArrow) {
                      <div
                        class="arrow arrow-left"
                        (click)="currentPlatform === CurrentPlatform.desktop ? scrollLeft() : null"
                      >
                        <img src="assets/images/icons-svg/arrow-right-big.svg" />
                      </div>
                    }
                    @if (showRightArrow) {
                      <div
                        class="arrow arrow-right"
                        (click)="currentPlatform === CurrentPlatform.desktop ? scrollRight() : null"
                      >
                        <img src="assets/images/icons-svg/arrow-right-big.svg" />
                      </div>
                    }
                  }
                </div>
              }
              @if (form['poll'].value) {
                <div
                  class="create-post__form-poll"
                  (click)="isMobModalOpen ? openPollBottomSheet() : openPollWebModal()"
                >
                  <app-file-upload
                    [fileTitle]="form['poll'].value.text"
                    [fileSubtitle]="'Опрос'"
                    [isDisabled]="isEditMode"
                    [type]="'poll'"
                    (deleteItem)="!isEditMode ? deletePoll() : ''"
                    [currentPlatform]="currentPlatform"
                  ></app-file-upload>
                </div>
              }
            </ion-row>
          </div>
        </ion-grid>
      </form>
      @if (
        isCreatePostOpen || isCreatePollOpen || form['poll'].value || isMobModalOpen || isEditMode
      ) {
        <ion-footer
          [class.footer-height]="currentPlatform === CurrentPlatform.desktop"
          [class.ion-no-border]="currentPlatform !== CurrentPlatform.desktop"
        >
          @if (error) {
            <div class="error-block">
              <div class="error-block__text" [textContent]="error.message"></div>
              <div class="tooltip">
                <img src="assets/images/icons-svg/info.svg" />
                <div class="tooltip-content">
                  <div class="tooltip-content__text">
                    <span class="tooltip-content__text_bold">Форматы: </span>
                    <span [textContent]="error.formats"></span>
                  </div>
                  <div class="tooltip-content__text">
                    <span class="tooltip-content__text_bold">Размер: </span>
                    до 10 MB
                  </div>
                </div>
              </div>
            </div>
          }
          <ion-toolbar>
            <ion-buttons
              slot="start"
              class="options"
              [class.no-poll-view]="currentUser.userRole !== userRoles.moderator"
            >
              <input
                #imageInput
                type="file"
                [accept]="availableImageFormats"
                (change)="handleUploadFile($event, chosenFiles)"
                multiple
                [style.display]="'none'"
              />
              <input
                #cameraInput
                type="file"
                accept="image/*"
                capture="environment"
                (change)="handleUploadFile($event, chosenFiles)"
                [style.display]="'none'"
              />
              <input
                #fileInput
                type="file"
                [accept]="allowedFormatsForFile.join(', ')"
                (change)="handleUploadFile($event, chosenFiles, allowedFormatsForFile)"
                [style.display]="'none'"
              />
              <app-image
                [img]="postModalMenuOptions[0].img"
                [class.disable]="
                  (chosenFiles.length && chosenFiles[0].fileType !== FileType.image) ||
                  chosenFiles.length >= fileLimit
                "
                (click)="openImageSource()"
              ></app-image>
              <app-image
                [img]="postModalMenuOptions[1].img"
                [class.disable]="chosenFiles.length"
                (click)="!chosenFiles.length && fileInput.click()"
              ></app-image>
              @if (currentUser.userRole === userRoles.moderator) {
                <app-image
                  [img]="postModalMenuOptions[2].img"
                  (click)="isMobModalOpen ? openPollBottomSheet() : openPollWebModal()"
                  [class.disable]="isEditMode || !!form['poll'].value"
                ></app-image>
                <app-image
                  [img]="isPinned ? postModalMenuOptions[4].img : postModalMenuOptions[3].img"
                  (click)="changeIsPinnedValue()"
                ></app-image>
              }
            </ion-buttons>
            <ion-buttons slot="end">
              <div
                [ngClass]="
                  isMobModalOpen || (isEditMode && currentPlatform !== CurrentPlatform.desktop)
                    ? 'submit-btn-mob'
                    : 'submit-btn-web'
                "
              >
                <app-button
                  [btnType]="
                    isMobModalOpen || (isEditMode && currentPlatform !== CurrentPlatform.desktop)
                      ? Buttons.small
                      : Buttons.base
                  "
                  [textSize]="ButtonTextSizes.h6BtnSmall"
                  [text]="isMobModalOpen ? 'Готово' : isEditMode ? 'Сохранить' : 'Опубликовать'"
                  [isDisabled]="!checkCanToSavePost(chosenFiles)"
                  (click)="confirmPostCreation(currentUser.userDepartment.id, chosenFiles)"
                ></app-button>
              </div>
            </ion-buttons>
          </ion-toolbar>
        </ion-footer>
      }
    }
  </div>
}

@if ((currentPlatform$ | async) === CurrentPlatform.desktop && isEditMode) {
  <div class="close-button" (click)="closeModal()">
    <app-svg icon="close"></app-svg>
  </div>
}
